import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { SectionLabel } from "./sharedUI";

const FOUNDER_PORTRAIT = "https://customer-assets-39nsmqrw.emergentagent.net/job_888d19bb-6d1f-4406-ae28-13dde7109b69/artifacts/8gi82110_ChatGPT%20Image%20Aug%2018%2C%202026%2C%2005_40_16%20PM.png";

export const FounderSection = () => (
  <section className="py-20 lg:py-32 border-b border-[color:var(--border-soft)]" data-testid="founder-section">
    <div className="max-w-[1280px] mx-auto px-6 lg:px-10">
      <SectionLabel n="05" name="The person behind it" />

      <div className="grid grid-cols-12 gap-8 lg:gap-16 items-start">
        {/* Portrait */}
        <div className="col-span-12 md:col-span-5 lg:col-span-5">
          <div className="relative">
            <div className="aspect-[4/5] bg-[color:var(--bg-alt)] border border-[color:var(--border-soft)] rounded-sm overflow-hidden relative">
              <div className="flex items-center justify-between px-4 py-3 border-b border-[color:var(--border-soft)] bg-[color:var(--bg-paper)] relative z-10">
                <span className="grid-ref">FIG. 05.1 · Founder</span>
                <span className="stamp stamp-ink">Elliot</span>
              </div>
              <img
                src={FOUNDER_PORTRAIT}
                alt="Elliot, founder of ReadyTrades"
                loading="lazy"
                className="absolute inset-0 top-[49px] w-full h-[calc(100%-98px)] object-cover"
                style={{ transform: 'scale(1.18)', transformOrigin: 'center 90%' }}
              />
              <div className="absolute bottom-0 left-0 right-0 px-4 py-3 border-t border-[color:var(--border-soft)] bg-[color:var(--bg-paper)] flex items-center justify-between z-10">
                <span className="text-[12px] font-medium text-[color:var(--ink)]">Elliot · Founder</span>
                <span className="grid-ref">4:5 · Portrait</span>
              </div>
            </div>
          </div>
        </div>

        {/* Copy */}
        <div className="col-span-12 md:col-span-7 lg:col-span-7">
          <p className="grid-ref mb-4">A quiet studio, run by one person.</p>
          <h2 className="h-lg text-[color:var(--ink)]">
            <span className="font-serif-italic">"I wanted</span> independent tradespeople to have the kind of brand and website normally reserved for far bigger businesses."
          </h2>

          <div className="mt-8 space-y-4 text-[15px] leading-[1.7] text-[color:var(--muted)] max-w-xl">
            <p>
              ReadyTrades was created by a UK-based designer with a decade of branding, website and digital work behind them.
            </p>
            <p>
              You'll speak to Elliot personally on every project. No hand-off, no offshore team, no ticket queues — just direct conversations, drawings, and a website you sign off before it goes live.
            </p>
          </div>

          <div className="mt-8 flex items-center gap-3">
            <span className="stamp stamp-ink">Great Dunmow · Essex</span>
            <span className="grid-ref">Est. 2024</span>
          </div>

          <Link to="/about" className="btn-secondary mt-10" data-testid="founder-cta">
            More about ReadyTrades <ArrowRight size={14} />
          </Link>
        </div>
      </div>
    </div>
  </section>
);
